// extracted by mini-css-extract-plugin
export default {"socialSection":"SocialSection_socialSection__Ql5AY","socialIcons":"SocialSection_socialIcons__S-7Sn","sectionTitle":"SocialSection_sectionTitle__S6fuJ"};